module.exports = new __parcel__URL__("roles.38bbd767.svg").toString();